import { PGA_COM_HOST } from 'env'
import React, { useState } from 'react'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Popover from '@material-ui/core/Popover'
import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import LaunchOutlinedIcon from 'components/material-symbol/icons/Launch'
import PeopleOutlineOutlinedIcon from 'components/material-symbol/icons/PeopleOutline'
import InsertChartOutlinedOutlinedIcon from 'components/material-symbol/icons/InsertChartOutlined'
import FileCopyOutlinedIcon from 'components/material-symbol/icons/FileCopy'
import DeleteIcon from 'components/material-symbol/icons/Delete'
import { useLoadGroupEventFormValues } from 'components/group-events/create-group-event-form-wizard/hooks'
import CancelGroupEventDialog from 'components/cancel-group-event-dialog'
import { useAuth } from 'lib/auth'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  menuItemIcon: {
    color: theme.palette.text.primary,
    minWidth: theme.spacing(5),
  },
  cancelMenuItem: {
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(1.25),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}))

const EventsActionsMenu = ({
  event,
  isOpen,
  handleClose,
  anchorEl,
  setIsDetailsOpen,
}) => {
  const classes = useStyles()
  const { user } = useAuth()
  const loadGroupEventFormValues = useLoadGroupEventFormValues()
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false)

  const userIsAssistantCoach = event.assistantCoaches?.some(
    coach => coach.id === user.id,
  )
  const canCancelEvent =
    !event.isCanceled && !event.isPast() && !userIsAssistantCoach

  const menuItems = [
    {
      Icon: LaunchOutlinedIcon,
      text: 'View Published Page',
      onClick: () =>
        window.open(`${PGA_COM_HOST}/things-to-do/events/${event.slug}`),
    },
    !event.externalRegistrationUrl
      ? {
        Icon: PeopleOutlineOutlinedIcon,
        text: 'View Attendees',
        onClick: () => setIsDetailsOpen('participants'),
      }
      : null,
    {
      Icon: InsertChartOutlinedOutlinedIcon,
      text: 'View Stats',
      onClick: () => setIsDetailsOpen('stats'),
    },
    {
      Icon: FileCopyOutlinedIcon,
      text: 'Duplicate',
      onClick: () => loadGroupEventFormValues(event),
    },
  ]

  const renderMenuItem = ({ Icon, text, onClick }) => (
    <MenuItem key={text} onClick={onClick}>
      <ListItemIcon className={classes.menuItemIcon}>
        <Icon fontSize="small" />
      </ListItemIcon>
      {text}
    </MenuItem>
  )

  return (
    <>
      <Popover
        open={isOpen}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuList autoFocusItem onClick={handleClose}>
          {menuItems.filter(item => item).map(renderMenuItem)}
          {canCancelEvent ? (
            <MenuItem
              className={classes.cancelMenuItem}
              onClick={() => setIsCancelDialogOpen(true)}
            >
              <ListItemIcon className={classes.menuItemIcon}>
                <DeleteIcon fontSize="small" />
              </ListItemIcon>
              Cancel Event
            </MenuItem>
          ) : null}
        </MenuList>
      </Popover>
      {canCancelEvent && isCancelDialogOpen ? (
        <CancelGroupEventDialog
          event={event}
          isOpen={isCancelDialogOpen}
          onClose={() => setIsCancelDialogOpen(false)}
        />
      ) : null}
    </>
  )
}

export default EventsActionsMenu
